<div class="page-content-wrapper">
    <div class="col">
        <div class="row g-4">
            <div class="col-sm-12 col-md-6 col-lg-4">
                <icon-card title="Total Applications" :count="total_applications" icon_class="fas fa-file-alt" />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
                <icon-card title="Applications Completed" :count="completed_applications" icon_class="fas fa-check-circle" />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
                <icon-card title="Applications Incomplete" :count="incomplete_applications" icon_class="fas fa-exclamation-circle" />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <icon-card title="Total Customers" :count="total_customers" icon_class="fas fa-users" />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <icon-card title="Total Services" :count="total_services" icon_class="fas fa-cogs" />
            </div>
        </div>
    </div>

    <div class="card rounded-3 mt-4 p-0 shadow-md">
        <div class="card-header bg-white border-0 me-2 d-flex justify-content-between align-items-center">
            <p class="text-s fw-bold">
                Workflow Customers
            </p>
        </div>
        <div class="card-body">
            <CustomTable
                :columns="columns"
                :fetchData="fetch_workflow_customers"
                :hasActions="true"
                tableKey="workflow_customers"
                >
                <template v-slot:cell-name_email="{ row }">
                    {{ row.first_name || row.full_name }} {{ row.last_name || '' }}
                    <p class="text-xxs fw-bold">{{ row.email }}</p>
                </template>
                <template v-slot:cell-date_joined="{ row }">
                    {{ formatDate(row.date_joined) }}
                </template>
                <template v-slot:actions="{ row }">
                    <button class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow" @click="view_customer(row.id)">
                        View
                    </button>
                </template>
            </CustomTable>
        </div>
    </div>
</div>